import { IconClockLine, Text } from "@instructure/ui";
import { useTranslation } from "react-i18next";

const TimeoutBody = () => {
  const { t } = useTranslation();

  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ marginBottom: "1.5rem" }}>
        <IconClockLine color="warning" size="medium" />
      </div>
      <Text size="medium" as="p" weight="bold" color="primary">
        {t("finalizeCourse.timeoutBody")}
      </Text>
    </div>
  );
};

export default TimeoutBody;
